import { useState } from 'react'
import type { FormEvent } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Option = { id: string; label: string }
type Config = { options?: Option[]; multiple?: boolean }

/** Single or multiple choice. Submits { optionIds: string[] }. */
export function ChoicePuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const config = puzzle.publicConfig as Config
  const options = config.options ?? []
  const multiple = config.multiple === true
  const [selected, setSelected] = useState<string[]>([])

  function toggle(id: string) {
    if (multiple) setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]))
    else setSelected([id])
  }

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (selected.length === 0) return
    void onSubmit({ optionIds: selected })
  }

  return (
    <form onSubmit={handleSubmit} className="puzzle-form">
      <fieldset disabled={disabled}>
        <legend className="muted">{multiple ? 'Select all that apply' : 'Select one'}</legend>
        <div className="options">
          {options.map((o) => (
            <label key={o.id} className={`option${selected.includes(o.id) ? ' selected' : ''}`}>
              <input
                type={multiple ? 'checkbox' : 'radio'}
                name="choice"
                value={o.id}
                checked={selected.includes(o.id)}
                onChange={() => toggle(o.id)}
              />
              <span>{o.label}</span>
            </label>
          ))}
        </div>
      </fieldset>
      <button type="submit" className="primary" disabled={disabled || selected.length === 0}>
        {disabled ? 'Checking…' : 'Submit answer'}
      </button>
    </form>
  )
}
